import CountryFlag from "./CountryFlag";
import MissingTokenIcon from "../icons/MissingTokenIcon";
import { TOKENS_WITHOUT_ICONS } from "./constants";

function IconMapping(symbol: string, size = 30) {
  // FIAT
  if (symbol === "aud") return <CountryFlag size={size} countrycode={"au"} />;
  if (symbol === "usd") return <CountryFlag size={size} countrycode={"us"} />;
  if (symbol === "nzd") return <CountryFlag size={size} countrycode={"nz"} />;
  if (symbol === "usd") return <CountryFlag size={size} countrycode={"us"} />;
  if (symbol === "eur") return <CountryFlag size={size} countrycode={"eu"} />;
  if (symbol === "jpy") return <CountryFlag size={size} countrycode={"jp"} />;
  if (symbol === "gbp") return <CountryFlag size={size} countrycode={"gb"} />;
  if (symbol === "cad") return <CountryFlag size={size} countrycode={"ca"} />;
  if (symbol === "vnd") return <CountryFlag size={size} countrycode={"vn"} />;
  if (symbol === "chf") return <CountryFlag size={size} countrycode={"ch"} />;
  if (symbol === "dkk") return <CountryFlag size={size} countrycode={"dk"} />;
  if (symbol === "hkd") return <CountryFlag size={size} countrycode={"hk"} />;
  if (symbol === "inr") return <CountryFlag size={size} countrycode={"in"} />;
  if (symbol === "nok") return <CountryFlag size={size} countrycode={"no"} />;
  if (symbol === "sgd") return <CountryFlag size={size} countrycode={"sg"} />;
  if (symbol === "php") return <CountryFlag size={size} countrycode={"ph"} />;

  // TOKENS
  if (TOKENS_WITHOUT_ICONS.includes(symbol.toUpperCase())) {
    return <MissingTokenIcon size={size.toString()} />;
  }
  return <></>;
}

export default IconMapping;
